module.exports = __webpack_public_path__ + "img/mic-mute.16e453be.svg";